import { IAplosApiRequestArgs } from "@/services/aplosApi";

export interface GetExecutionConfigArgsOptions {
    userId: string;
    tenantId: string;
    executionId: string;
}

export class GetExecutionConfigArgs implements IAplosApiRequestArgs {

    public userId: string;
    public tenantId: string;
    public executionId: string;

    constructor(options: GetExecutionConfigArgsOptions) {

        if (options.userId == null) throw Error("userId is required");
        if (options.tenantId == null) throw Error("tenantId is required");
        if (options.executionId == null) throw Error("executionId is required");

        this.userId = options.userId;
        this.tenantId = options.tenantId;
        this.executionId = options.executionId;
    }


}